export default "__VITE_ASSET__CKYLsBQk__"